import useApi, { ApiOptions } from '../base/useApi';
import ScanConsultantReviewDTO from '@src/adapters/dto/scan/ScaneConsultantReviewDTO';

interface Params {
  consultantId: string;
  hospitalId?: string;
}

interface Result {
  scans: ScanConsultantReviewDTO[];
}

const options: ApiOptions = {
  method: 'get',
  urlPath: '/scan/unreviewed_for_consultant',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
};

export const useFindScansUnreviewedByConsultant = (params?: Params) => {
  options.lazy = false;
  return useApi<Params, Result>(options, params);
};

export const useFindScansUnreviewedByConsultantLazy = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};

export default useFindScansUnreviewedByConsultant;
